import React from 'react';
import Text from './Text';
import Audio from './Audio';
import { useSelector } from 'react-redux';
import { sproutsAgentSelector } from 'src/store/sprouts-agent/sprouts-agent.selector';
import Lottie from 'lottie-react';
import PaulaAnimation from 'src/lottie-animations/PaulaAnimation.json';
interface InputProps {
  audioRef: any;
  handleTimeUpdateRef: any;
  abortControllerRef: any;
}
const InputSection: React.FC<InputProps> = ({
  audioRef,
  handleTimeUpdateRef,
  abortControllerRef,
}) => {
  const { audioVisualizerOpen, messages, isAgentSpeaking } = useSelector(sproutsAgentSelector);
  return (
    <div className={`input-section-container ${(audioVisualizerOpen || messages.length > 0) && 'dec-height'}`}>
      <div
        className={`paula-animaton ${(messages.length > 0 || audioVisualizerOpen) && 'pull-down'} ${
          isAgentSpeaking && 'expand-circle'
        }`}
      >
        <Lottie animationData={PaulaAnimation} loop={true} autoplay={true} />
      </div>
      {!audioVisualizerOpen && messages.length === 0 && (
        <p className="sub-text">
          <p className="up">Hey, Im Paula,</p>
          <p className="down">what’s on your mind today?</p>
        </p>
      )}
      {audioVisualizerOpen ? (
        <Audio
          audioRef={audioRef}
          handleTimeUpdateRef={handleTimeUpdateRef}
          abortControllerRef={abortControllerRef}
        />
      ) : (
        <Text
          audioRef={audioRef}
          handleTimeUpdateRef={handleTimeUpdateRef}
          abortControllerRef={abortControllerRef}
        />
      )}
    </div>
  );
};

export default InputSection;
